// @ts-nocheck
(function () {
    const logo = document.getElementById('landing-logo-animated');
    if (!logo) return;

    // Attivati solo sulla landing page (password page o index con classe specifica)
    // Se vuoi limitarlo a un template specifico decommenta:
    // if (!document.body.classList.contains('template-password')) return;

    function isMobile() { return window.innerWidth < 750; }
    function vw() { return window.innerWidth / 100; }
    function lerp(a, b, t) { return a + (b - a) * t; }

    // Dimensioni logo: uguale all'originale
    // START = grande al centro della hero
    // END   = piccolo bloccato in alto al centro (nessuna header target, solo top fisso)
    const FIXED_TOP_PX = 24; // px dal top quando bloccato
    const FIXED_END_VW_DESK = 9.861;
    const FIXED_END_VW_MOB = 28.462;

    function getEndPosition() {
        const mobile = isMobile();
        const endVw = mobile ? FIXED_END_VW_MOB : FIXED_END_VW_DESK;
        const endW = endVw * vw();
        const endH = endW * (319 / 744);
        return {
            x: window.innerWidth / 2,
            y: FIXED_TOP_PX + endH / 2,  // centrato verticalmente sulla sua altezza finale
            vw: endVw
        };
    }

    function update() {
        const mobile = isMobile();
        const START_VW = mobile ? 90.513 : 51.667;

        const heroRect = document.querySelector('.landing-hero')?.getBoundingClientRect();
        if (!heroRect) return;

        const end = getEndPosition();

        const heroCenter = heroRect.top + heroRect.height / 2;
        const screenMid = window.innerHeight / 2;

        // progress 0 = logo centrato nella hero (grande)
        // progress 1 = logo bloccato in alto (piccolo)
        // transizione: heroCenter va da screenMid → end.y
        let progress = (screenMid - heroCenter) / (screenMid - end.y);
        progress = Math.min(Math.max(progress, 0), 1);

        const currentW = lerp(START_VW, end.vw, progress) * vw();
        const currentH = currentW * (319 / 744);

        // Start: centro della hero nella viewport
        const startX = window.innerWidth / 2;
        const startY = heroRect.top + heroRect.height / 2;

        const x = lerp(startX, end.x, progress);
        const y = lerp(startY, end.y, progress);

        logo.style.position = 'fixed';
        logo.style.width = currentW + 'px';
        logo.style.height = currentH + 'px';
        logo.style.left = (x - currentW / 2) + 'px';
        logo.style.top = (y - currentH / 2) + 'px';
        logo.style.opacity = '1';
        logo.style.zIndex = '100';

        // Colore: bianco fisso (no header dark logic)
        // const paths = logo.querySelectorAll('path');
        // paths.forEach(p => p.setAttribute('fill', 'white'));

        
        // Colore: solo i path del bianco, non toccare il nero
        const svgBianco = logo.querySelector('.logo-svg-bianco');
        if (svgBianco) {
            const paths = svgBianco.querySelectorAll('path');
            paths.forEach(p => p.setAttribute('fill', 'white'));
        }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);

})();